

export namespace TextUtis {
  export function firstToUpperCase(value: string) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}